import { render, staticRenderFns } from "./UserLike.vue?vue&type=template&id=7932342c&scoped=true&"
import script from "./UserLike.vue?vue&type=script&lang=js&"
export * from "./UserLike.vue?vue&type=script&lang=js&"
import style0 from "./UserLike.vue?vue&type=style&index=0&id=7932342c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7932342c",
  null
  
)

export default component.exports